import { Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "@/redux/store";
import PageLoader from "@/components/PageLoader";
import "./index.css";
// import './style/app.css';

const NixodErp = lazy(() => import("./app/NixodErp"));

export default function RoutApp() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Suspense fallback={<PageLoader />}>
          <NixodErp />
        </Suspense>
      </Provider>
    </BrowserRouter>
  );
}
